// src/stores/uiStore.js
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const useUIStore = create(
    persist(
        (set, get) => ({
            // State
            theme: 'auto', // 'light', 'dark', 'auto'
            sidebarOpen: false,
            showDeviceDetails: {},
            showDeviceSettings: {},
            globalControlsExpanded: true,
            currentView: 'dashboard', // 'dashboard', 'devices', 'settings'

            // Module collapsed states (key: moduleKey, value: boolean expanded)
            moduleExpanded: {},
            // Integration filter tab
            integrationTab: 'all',

            // Loading states
            loadingStates: {},

            // Actions
            setTheme: (theme) => {
                set({ theme })

                // Apply theme to document
                const root = document.documentElement
                if (theme === 'dark') {
                    root.classList.add('dark')
                } else if (theme === 'light') {
                    root.classList.remove('dark')
                } else {
                    // Auto theme - check system preference
                    const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches
                    if (isDark) {
                        root.classList.add('dark')
                    } else {
                        root.classList.remove('dark')
                    }
                }
            },

            toggleSidebar: () => {
                set(state => ({ sidebarOpen: !state.sidebarOpen }))
            },

            closeSidebar: () => set({ sidebarOpen: false }),

            toggleDeviceDetails: (mac) => {
                set(state => ({
                    showDeviceDetails: {
                        ...state.showDeviceDetails,
                        [mac]: !state.showDeviceDetails[mac]
                    }
                }))
            },

            toggleDeviceSettings: (mac) => {
                set(state => ({
                    showDeviceSettings: {
                        ...state.showDeviceSettings,
                        [mac]: !state.showDeviceSettings[mac]
                    }
                }))
            },

            toggleGlobalControls: () => {
                set(state => ({ globalControlsExpanded: !state.globalControlsExpanded }))
            },

            setCurrentView: (view) => set({ currentView: view }),

            setModuleExpanded: (key, expanded) => {
                set(state => ({
                    moduleExpanded: { ...state.moduleExpanded, [key]: expanded }
                }))
            },

            getModuleExpanded: (key, defaultVal = true) => {
                const val = get().moduleExpanded[key]
                return val !== undefined ? val : defaultVal
            },

            setIntegrationTab: (tab) => set({ integrationTab: tab }),

            // Loading state management
            setLoading: (key, isLoading) => {
                set(state => ({
                    loadingStates: {
                        ...state.loadingStates,
                        [key]: isLoading
                    }
                }))
            },

            isLoading: (key) => {
                return get().loadingStates[key] || false
            },

            // Initialize theme
            initializeTheme: () => {
                const { theme } = get()
                get().setTheme(theme)

                // Listen for system theme changes
                const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
                mediaQuery.addEventListener('change', (e) => {
                    if (get().theme === 'auto') {
                        if (e.matches) {
                            document.documentElement.classList.add('dark')
                        } else {
                            document.documentElement.classList.remove('dark')
                        }
                    }
                })
            }
        }),
        {
            name: 'ui-storage',
            partialize: (state) => ({
                theme: state.theme,
                globalControlsExpanded: state.globalControlsExpanded,
                currentView: state.currentView,
                moduleExpanded: state.moduleExpanded,
                integrationTab: state.integrationTab,
            })
        }
    )
)
